/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.4 routes of Sunset::Application.
 * @version feaff861de8e12cfba3ef2e309baf22e03e4bcf5170f4c39987bff288236480b
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /beer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const beer_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"beer"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/cart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cart_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/checkout_option(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_option_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"checkout_option"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /club(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const club_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"club"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /commercial_information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const commercial_information_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"commercial_information"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /products/confirm_payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_payment_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"confirm_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/create_payment_intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_payment_intent_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"create_payment_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /members/billing_informations/create_setup_intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_setup_intent_members_billing_informations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"billing_informations"],[2,[7,"/"],[2,[6,"create_setup_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gifts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gift_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gifts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gifts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gifts_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"gifts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /japan_guide(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const japan_guide_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"japan_guide"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /kidlit-10th-anniversary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kidlit_anniversary_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"kidlit-10th-anniversary"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /kidlit-10th-anniversary/confirm_payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kidlit_anniversary_confirm_payment_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"kidlit-10th-anniversary"],[2,[7,"/"],[2,[6,"confirm_payment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /kidlit-10th-anniversary/payment_intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kidlit_anniversary_payment_intent_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"kidlit-10th-anniversary"],[2,[7,"/"],[2,[6,"payment_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /kidlit-10th-anniversary/thanks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kidlit_anniversary_thanks_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"kidlit-10th-anniversary"],[2,[7,"/"],[2,[6,"thanks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /kidmit-10th-anniversary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kidmit_10th_anniversary_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"kidmit-10th-anniversary"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /members/app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_app_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"app"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /members/billing_informations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_billing_informations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"billing_informations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /members/gift_addresses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_gift_address_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"gift_addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /members/gift_addresses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_gift_addresses_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"gift_addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /members/gift_invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_gift_invitation_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"gift_invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /members/gift_invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_gift_invitations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"gift_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /members/mypage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_mypage_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"mypage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /members/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_orders_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /members/shipments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_shipments_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"shipments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /members/user_informations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const members_user_informations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"user_informations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/campaings/neko(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const neko_pages_campaings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"campaings"],[2,[7,"/"],[2,[6,"neko"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/campaings/neko_vote(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const neko_vote_pages_campaings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"campaings"],[2,[7,"/"],[2,[6,"neko_vote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/campaings/neko_voted(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const neko_voted_pages_campaings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"campaings"],[2,[7,"/"],[2,[6,"neko_voted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /members/billing_informations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_members_billing_information_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"billing_informations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /members/gift_addresses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_members_gift_address_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"gift_addresses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /members/gift_invitations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_members_gift_invitation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"gift_invitations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /us_users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_us_user_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"us_users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onsen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onsen_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"onsen"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /osusowake(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const osusowake_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"osusowake"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pages/campaings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_campaings_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"campaings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /privacy_policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_policy_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"privacy_policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pages/events/releaseparty2024fall(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const releaseparty2024fall_pages_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"releaseparty2024fall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/events/releaseparty2024winterForSony(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const releaseparty2024winterForSony_pages_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"releaseparty2024winterForSony"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/events/releaseparty2024winter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const releaseparty2024winter_pages_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"releaseparty2024winter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/events/releaseparty2025fall(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const releaseparty2025fall_pages_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"releaseparty2025fall"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/events/releaseparty2025spring(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const releaseparty2025spring_pages_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"releaseparty2025spring"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/events/releaseparty2025summer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const releaseparty2025summer_pages_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"releaseparty2025summer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/events/releaseparty2025winter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const releaseparty2025winter_pages_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"releaseparty2025winter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/events/releaseparty2026spring(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const releaseparty2026spring_pages_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"releaseparty2026spring"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/remove_cart_item(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_cart_item_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"remove_cart_item"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reservation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reservation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"reservation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /restaurants(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restaurants_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"restaurants"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /products/result(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const result_products_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"result"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /tasting_room(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tasting_room_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tasting_room"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /team(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"team"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /terms_of_use(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_of_use_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms_of_use"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /us_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const us_users_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"us_users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /us_users/activate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const us_users_activate_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"us_users"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /us_users/phone_login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const us_users_phone_login_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"us_users"],[2,[7,"/"],[2,[6,"phone_login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /us_users/phone_login_sent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const us_users_phone_login_sent_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"us_users"],[2,[7,"/"],[2,[6,"phone_login_sent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /us_users/sign_in_with_phone(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const us_users_sign_in_with_phone_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"us_users"],[2,[7,"/"],[2,[6,"sign_in_with_phone"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /us_users/validate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const us_users_validate_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"us_users"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /video(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const video_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"video"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wines(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wines_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"wines"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pages/events/yugawara202405(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yugawara202405_pages_events_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"yugawara202405"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

